import request from '@/utils/request'
import { v2Host } from '@/config/host'

/**
 * getVideoTagList
 * http://playable.dev.com:8067/index.html?urls.primaryName=%E4%BB%93%E5%BA%93%E5%90%8E%E5%8F%B0%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/system/get_system_video_tag_list
 */
export function getVideoTagList() {
  return request({
    url: `${v2Host}/system/video-tag/list`,
    method: 'get',
  })
}

/**
 * 创建标签
 * @param {{pid: number, name: string, is_required: number}} data
 */
export function createVideoTag(data) {
  return request({
    url: `${v2Host}/system/video-tag/create`,
    method: 'post',
    data: data,
  })
}

/**
 * 更新标签
 * @param {{id: number}}
 * @param {{name: string, is_required: number, is_hidden: number}} data
 */
export function updateVideoTag(params, data) {
  return request({
    url: `${v2Host}/system/video-tag/update`,
    method: 'post',
    params: params,
    data: data,
  })
}

/**
 * 删除标签
 * @param {{id: number}} params
 */
export function deleteVideoTag(params) {
  return request({
    url: `${v2Host}/system/video-tag/delete`,
    method: 'post',
    params: params,
  })
}
